import { createElement } from 'react';
import styled from 'styled-components';
import { ReactComponent as TableIcon } from '@elementary/common-ui/assets/16x16/table.svg';
import { ReactComponent as ColumnIcon } from '@elementary/common-ui/assets/columns.svg';
import {
  Flex,
  FlexColumn,
  FormControls,
} from '@elementary/common-ui/components';
import { getTestIcon } from '@elementary/common-ui/components/cellRenderers/testNameRenderer';
import { Typography } from '@mui/material';
import { UseFormWatch } from 'react-hook-form';
import { AddTestForm } from 'shared/types';
import ChangesReviewList from '../ChangesReviewList';
import { changeRenderers, REVIEW_FIELDS } from './constants';

const TableIconStyled = styled(TableIcon)`
  width: 17px;
  min-width: 17px;
`;

const ColumnIconStyled = styled(ColumnIcon)`
  width: 17px;
  min-width: 17px;
`;

type Props = {
  watch: UseFormWatch<AddTestForm>;
  testType?: string;
  testSubType?: string;
  resourceName?: string;
  testName?: string;
  originalFormValues: Partial<AddTestForm>;
};

const EditTestWizardReviewStage = ({
  watch,
  testType,
  testSubType,
  resourceName,
  testName,
  originalFormValues,
}: Props) => {
  const changedFields = REVIEW_FIELDS.filter(
    (field) =>
      JSON.stringify(originalFormValues[field] || {}) !==
      JSON.stringify(watch(field) || {}),
  );

  const changes = changedFields.map((field) => ({
    title: field,
    originalValue: originalFormValues[field],
    updatedValue: watch(field),
    renderer: changeRenderers[field],
  }));

  return (
    <FlexColumn sx={{ gap: 2, p: 3 }}>
      <FormControls.TestAccordion summary="Test details">
        <Flex sx={{ gap: 2, p: 3 }}>
          <Flex sx={{ alignItems: 'center', gap: 1 }}>
            {createElement(
              getTestIcon(testType || '', testSubType || '') || (() => null),
            )}
            <Typography sx={{ fontWeight: 500 }}>{testName}</Typography>
          </Flex>
          <Flex sx={{ alignItems: 'center', gap: 1 }}>
            {watch('resourceType') === 'columns' ? (
              <ColumnIconStyled />
            ) : (
              <TableIconStyled />
            )}
            <Typography sx={{ fontWeight: 500 }}>{resourceName}</Typography>
          </Flex>
        </Flex>
      </FormControls.TestAccordion>

      <FormControls.TestAccordion summary="Test modifications" defaultExpanded>
        <FlexColumn sx={{ gap: 3, p: 3 }}>
          <ChangesReviewList changes={changes} />
        </FlexColumn>
      </FormControls.TestAccordion>
    </FlexColumn>
  );
};

export default EditTestWizardReviewStage;
